import { render, staticRenderFns } from "./MatchPayFailStep.vue?vue&type=template&id=714c6694"
import script from "./MatchPayFailStep.vue?vue&type=script&lang=js"
export * from "./MatchPayFailStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports